import MobileFooter from '../../components/Mobile/MobileFooter';
import MobileCartFooter from '../../components/Mobile/MobileCartFooter';

const MobileCart = () => {
    return (
        <div>
          <h1>Cart tut budet</h1>
            <MobileCartFooter />
          <MobileFooter />
        </div>
    );
}

export default MobileCart;